module.exports = __webpack_public_path__ + "img/bg-login-new.867ac523.png";